import React from 'react';
import { Modal, Form, Input, Checkbox, Button, Space, InputNumber, Select, Divider } from 'antd';
import { layout, tailLayout, formStyle } from 'containers/common/layout';

interface IProps {
    dataId: number,
    editorVisible: boolean,
    editorTitle: string,
    onCancel: any,
}

const { Option } = Select;

class AftersaleConfigEdit extends React.Component<IProps> {
    constructor(props: any) {
        super(props);
    }

    state = {
        visible: false
    };

    cancelModal = () => {
        this.props.onCancel();
    }

    onFinish = (values: any) => {
        console.log('Success:', values);
    };

    onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
    };

    render() {
        return (
            <div>
                <Modal
                    title={this.props.editorTitle}
                    visible={this.props.editorVisible}
                    onCancel={this.cancelModal}
                    footer={null}
                    destroyOnClose={true}
                    maskClosable={false}
                >
                    <Form
                        {...layout}
                        name="basic"
                        initialValues={{ remember: true }}
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                        size="large"
                        style={formStyle}
                    >
                        <Form.Item
                            label="申请类型"
                            name="type"
                            rules={[{ required: true, message: 'Please select!' }]}
                        >
                            <Select
                                style={{ width: '100%' }}
                            >
                                <Option value="1">售后</Option>
                                <Option value="2">退款</Option>
                            </Select>
                        </Form.Item>

                        <Form.Item
                            label="原因分类"
                            name="reasonType"
                            rules={[{ required: true, message: 'Please select!' }]}
                        >
                            <Select
                                style={{ width: '100%' }}
                            >
                                <Option value="1">天气原因</Option>
                                <Option value="2">行程有变</Option>
                                <Option value="3">态度问题</Option>
                            </Select>
                        </Form.Item>

                        <Form.Item
                            label="原因"
                            name="reason"
                            rules={[{ required: true, message: 'Please select!' }]}
                        >
                            <Select
                                style={{ width: '100%' }}
                            >
                                <Option value="1">导游态度恶劣</Option>
                                <Option value="2">天气变化导致行程取消</Option>
                                <Option value="3">临时有事，无法如期出行</Option>
                            </Select>
                        </Form.Item>

                        <Divider />

                        <Form.Item {...tailLayout}>
                            <Space size="large">
                                <Button onClick={this.cancelModal}>取消</Button>
                                <Button type="primary" htmlType="submit">确认提交</Button>
                            </Space>

                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        )
    }
}

export default AftersaleConfigEdit;